"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level1StateDTO = void 0;
const enums_1 = require("../enums");
class Level1StateDTO {
    constructor() {
        // the thing which is actively being categorized.
        this.activeThing = null;
        // the question on the active thing that is actively being answered.
        this.activeThingQuestionActive = null;
        // the count of first tries made in this instance of the level.
        this.firstTries = 0;
        // the things correctly categorized as living.
        this.living = [];
        // maximum number of points possible for the level.
        this.maxPoints = 0;
        // the things correctly categorized as nonliving.
        this.nonliving = [];
        // current number of points the player has on the level.
        this.points = 0;
        // the current status of the level.
        this.status = enums_1.LevelStatus.START;
        // thing states
        this.things = [];
        // the uncategorized things.
        this.uncategorized = [];
        // number of points required to reach next level.
        this.unlockPoints = 0;
    }
}
exports.Level1StateDTO = Level1StateDTO;
//# sourceMappingURL=Level1StateDTO.js.map